"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var DropDown_1 = __importDefault(require("../../../../common/DropDown/DropDown"));
var general_1 = require("../../../../lib/general");
var Queries_1 = require("../Graphql/Queries");
var ServiceCenterSelector = function (_a) {
    var value = _a.value, onChange = _a.onChange, error = _a.error, label = _a.label;
    var _b = (0, react_1.useState)([]), list = _b[0], setList = _b[1];
    var _c = (0, react_i18next_1.useTranslation)(), t = _c.t, i18n = _c.i18n;
    var _d = (0, client_1.useQuery)(Queries_1.GET_SERVICE_CENTER), data = _d.data, serviceCenterError = _d.error;
    (0, react_1.useEffect)(function () {
        var tmp = [];
        if ((data === null || data === void 0 ? void 0 : data.getServiceCenter.length) > 0) {
            data === null || data === void 0 ? void 0 : data.getServiceCenter.map(function (item) {
                var id = item.id, name = item.name;
                tmp.push({
                    value: id,
                    label: (0, general_1.isJsonWithAvailableLang)(name, i18n.language, t),
                });
            });
        }
        setList(tmp);
    }, [data]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DropDown_1.default, { label: label, options: list, value: value, onChange: onChange, error: error })));
};
exports.default = ServiceCenterSelector;
